import React, { useState } from 'react';
import node from '../node/img/node.jpg';
import css from '../node/img/css.png';
import python from "../node/img/python_icon.png";
import sql from  "../node/img/sql-icon.png";
import bash from "../node/img/bash.jpg";
import javascript from"../node/img/javascript.png";
import jquery from "../node/img/jquery.png";
import html from "../node/img/html.png";
import ang from "../node/img/AngularJS-Shield.svg";
import git from "../node/img/git.png";
import cplus from "../node/img/c++ icone.png";
import xml from "../node/img/xml.jpeg";
import Projects from '../core/Projects.js';
import '../node/css/style.css';
import './index.css';
import Footer from "../core/Footer"
import NoticeBanner from '../core/Noticebanner';





function App() {
  const skillGroups = [
    {
      title: 'Programming Languages',
      items: [
        { name: 'Python', icon: python, alt: 'python icon' },
        { name: 'SQL', icon: sql, alt: 'sql icon' },
        { name: 'JavaScript', icon: javascript, alt: 'javascript icon' },
        { name: 'Java' },
        { name: 'C++', icon: cplus, alt: 'c++ icon' },
        { name: 'Bash', icon: bash, alt: 'bash icon' }
      ]
    },
    {
      title: 'Web & Tools',
      items: [
        { name: 'HTML', icon: html, alt: 'html icon' },
        { name: 'CSS', icon: css, alt: 'css icon' },
        { name: 'jQuery', icon: jquery, alt: 'jquery icon' },
        { name: 'Node.js', icon: node, alt: 'node icon' },
        { name: 'AngularJS', icon: ang, alt: 'angularjs icon' },
        { name: 'Git', icon: git, alt: 'git icon' },
        { name: 'XML', icon: xml, alt: 'xml icon' }
      ]
    },
    {
      title: 'AWS Developer Associate',
      items: [
        { name: 'Lambda Development' },
        { name: 'API Gateway Integration' },
        { name: 'DynamoDB Data Modeling' },
        { name: 'S3 Event-Driven Workflows' },
        { name: 'SQS/SNS Messaging Patterns' },
        { name: 'CloudWatch Monitoring & Alarms' },
        { name: 'CI/CD with CodePipeline' },
        { name: 'IAM Roles for Applications' }
      ]
    },
    {
      title: 'AWS Solutions Architect',
      items: [
        { name: 'Well-Architected Design' },
        { name: 'VPC Multi-Tier Architecture' },
        { name: 'Auto Scaling & Load Balancing' },
        { name: 'Route 53 DNS & Failover' },
        { name: 'RDS High Availability Design' },
        { name: 'S3 Lifecycle & Storage Classes' },
        { name: 'Cost Optimization Strategies' },
        { name: 'Disaster Recovery Patterns' }
      ]
    },
    {
      title: 'AWS Cloud Security',
      items: [
        { name: 'IAM Policy Design' },
        { name: 'KMS Encryption Strategy' },
        { name: 'CloudTrail Monitoring' },
        { name: 'GuardDuty Detection' },
        { name: 'Security Hub Findings' },
        { name: 'AWS WAF Rules' },
        { name: 'VPC Security Controls' },
        { name: 'AWS Config Compliance' }
      ]
    },
    {
      title: 'Linux + Certification',
      items: [
        { name: 'Linux CLI Administration' },
        { name: 'Bash Scripting Automation' },
        { name: 'Systemd & Service Management' },
        { name: 'User/Group & File Permissions' },
        { name: 'SSH Hardening & Key Management' },
        { name: 'Log Analysis (syslog/journalctl)' },
        { name: 'Networking Tools (ss, netstat, tcpdump)' }
      ]
    }
  ];
  const [activeSkillGroup, setActiveSkillGroup] = useState(0);
  const currentSkillGroup = skillGroups[activeSkillGroup];
  const getSkillTag = (groupTitle, skillName) => {
    if (groupTitle.indexOf('AWS') === 0) {
      return 'AWS';
    }

    if (skillName === 'Java') {
      return 'JAVA';
    }

    return 'SKILL';
  };
  
  return (
    
    <div>

<NoticeBanner/>
       <header>

       <meta name="description" content="Kennashka DeSilva online portfolio and skillset." />
        <meta name="keywords" content="kennashka Desilva" />

        <div className="left-header">
          <div className="name" style={{  fontFamily:'roboto', fontSize:'27px'}}>Kennashka DeSilva</div>
          <div className="description">Cybersecurity Analyst</div>
        </div>
        <div className="right-header"><a href="#projects">Applications</a> | <a href="#skills">Expertise</a>
          | <a href="mailto:mail@kennashka.com">Contact</a> </div>
        {/* end of header info */}

        
      </header>
   

    <section id="home">
      <div className="overlay">
        {/* PRIMARY NAVIGATION */}
        <div className="container">
          <h1 className="text-center p-5"><small> Cloud/ Automation Dev and Security</small></h1>
          <ul className="social-links vertical-list">
            <li><a href="https://github.com/kennashka" className="noir github" target="_blank" rel="noopener noreferrer">Github</a></li>
          
          </ul>
        </div>
      </div>
    </section>
    <div className="container">
      <section id="projects">
        {/* Three columns of text below the carousel */}
        <div className="col-md-12">
          <h2 className="featurette-heading pt-5">Applications. <span className="text-muted">Code Repository.</span></h2>
          <div>
            <div className="container">
              <p id="title" />
              <div className="row">
              <Projects>
</Projects>
              </div>
            </div>
          </div>
        </div>
      </section>

  
      <section id="skills">
        <div className="container skills-shell"> 
          <h2 className="featurette-heading">Expertise. <span className="text-muted">Keeps getting better.</span></h2>
          <p className="lead skills-copy">
            Core programming skills and AWS cloud security capabilities.
          </p>
          <div className="skills-tabs" role="tablist" aria-label="Skill categories">
            {skillGroups.map((group, index) => (
              <button
                key={group.title}
                type="button"
                className={`skills-tab ${activeSkillGroup === index ? 'is-active' : ''}`}
                role="tab"
                aria-selected={activeSkillGroup === index}
                onClick={() => setActiveSkillGroup(index)}
              >
                {group.title}
              </button>
            ))}
          </div>
          <div className="skills-panel">
            <h3 className="skills-group-title">{currentSkillGroup.title}</h3>
            <div className="skills-grid">
              {currentSkillGroup.items.map((skill) => (
                <div className="skill-card" key={skill.name}>
                  {skill.icon ? (
                    <img className="skill-icon" src={skill.icon} width={72} height={72} alt={skill.alt} />
                  ) : (
                    <div className="skill-tag">{getSkillTag(currentSkillGroup.title, skill.name)}</div>
                  )}
                  <p className="skill-name">{skill.name}</p>
                </div>
              ))}
              </div>
          </div>
        </div>
      </section>

      
      {/* /END THE FEATURETTES */}
      {/* Footer */}


      <section>
        <h2 className="featurette-heading">Contact.</h2>
      </section></div>

<Footer/>
    
    </div>
  );
}

export default App;
